import { Exclude, Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../common/dimensions/dimension-option-code-raw-dto';

export class ARInvoiceItemRawDto {
    arInvoiceId: number;
    arInvoiceItemId: number;
    accountLabelCode: string;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    subCategoryCode: string;
    amount: number;
    description: string;
    crudAction: string;

    @Type(() => DimensionOptionCodeRawDto)
    dimensions: DimensionOptionCodeRawDto[];

    // Transient
    @Exclude()
    itemId: number;
    @Exclude()
    subCategory: string;
    @Exclude()
    isAccountSubcategoryValid: boolean;
    @Exclude()
    accountSubcategoryValidationMessage: string;
}
